export default __webpack_public_path__ + "static/media/p-calculator.563d3331.jpg";